import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxProps, Divider, Form, InputProps } from "semantic-ui-react";
import { ICert } from "../../models/ICert";
import { IPersonCert } from "../../models/IPersonCert";
import { DateInput, DateInputProps } from "semantic-ui-calendar-react";



interface PersonCertFormprops {
    cert: ICert;
    errors?: { [key in keyof IPersonCert]: string };
    initialData?: IPersonCert;
    onChange: (values: Partial<IPersonCert>) => void;
    disabled?: boolean;
    inputForCertStartDate?: boolean;
};

const PersonCertForm: React.FC<PersonCertFormprops> = ({
    cert,
    initialData,
    onChange,
    errors,
    disabled = false,
    inputForCertStartDate = true
}) => {
    const t = useTranslation().t;

    const texts = {
        valid: t("Voimassa"),
        cardImage: t("Korttikuva"),
        indentifier: t("Kortin numero tai muu tunniste"),
        starts: t("Alkaa"),
        ends: t("Päättyy")
    };

    const update = <T extends keyof IPersonCert>(key: T, value: IPersonCert[T]) => {
        onChange({ ...initialData, timelimited: cert.isTimeLimited, [key]: value })
    }

    const updateStarts: DateInputProps["onChange"] = (e, { name, value }) => {
        update("startsAt", value)
    };

    const updateEnds: DateInputProps["onChange"] = (e, { name, value }) => {
        update("endsAt", value);
    };


    const updateNumber: InputProps["onChange"] = (e, { name, value }) => {
        update("number", value)
    };

    const updateValidity: CheckboxProps["onChange"] = (e, { checked }) => {
        update("valid", checked)
    }


    return (
        <Fragment>

            {cert.name}

            <Divider hidden />
            {cert.isTimeLimited ? (
                <Form.Group >
                    {inputForCertStartDate && <DateInput
                        name="alkaa"
                        label={texts.starts}

                        localization="fi"
                        autoComplete="off"

                        dateFormat="DD.MM.YYYY"
                        hideMobileKeyboard
                        closable
                        onChange={updateStarts}
                        value={initialData?.startsAt || ""}
                        disabled={disabled}
                    />
                    }
                    <DateInput
                        required={initialData?.startsAt}
                        error={errors?.endsAt}
                        name="alkaa"
                        label={texts.ends}

                        localization="fi"
                        autoComplete="off"

                        dateFormat="DD.MM.YYYY"
                        hideMobileKeyboard
                        closable
                        onChange={updateEnds}
                        value={initialData?.endsAt || ""}
                        disabled={disabled}
                    />

                </Form.Group>
            ) : (
                <Fragment>
                    <Divider hidden />
                    <Form.Checkbox
                        label={texts.valid}
                        defaultChecked={Boolean(initialData?.valid)}
                        onChange={updateValidity}
                        disabled={disabled}
                    />
                </Fragment>
            )}

            <Form.Input
                label={texts.indentifier}
                onChange={updateNumber}
                value={initialData?.number}
                disabled={disabled}
            />

        </Fragment>
    );
};


export default PersonCertForm;
